import Deck from './deck.jsx';

export default Deck;
